import React from "react";

var Component = function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.17 9H15.1l-2.22-7.346A.93.93 0 0 0 11.999 1a.93.93 0 0 0-.881.654L8.807 9H1.866c-1.013 0-1.013 1-.631 1.382l5.68 4.254-2.3 7.104a.974.974 0 0 0 .329 1.072.906.906 0 0 0 1.092.009l5.962-4.386 5.962 4.386a.904.904 0 0 0 1.092-.008.974.974 0 0 0 .329-1.072l-2.3-7.104 5.68-4.254C23.145 10 23.145 9 22.17 9z",
    fill: "none",
    stroke: "#000",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }));
};

Component.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
Component.displayName = "star";
export default Component;